import React, { useEffect, useState } from 'react'
import { Formik } from "formik";
import AdminLayout from '../../../layouts/AdminLayout'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchAdminProfile } from '../../../redux/features/admin/actions/authAction';
import Eye from "../../../components/form/Eye";
import ErrorMessage from "../../../components/form/ErrorMessage";
import { changePasswordSchema } from "../../../utils/schema";
import { API_REQUEST } from "../../../redux/features";
import { adminChangePasswordEndPointURL, adminProfileEndPointURL } from "../../../routes/apiurls";
import { getProfile, setProfile } from "../../../utils/pip";
import Loader from '../../../components/loader';

const Setting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [saving, setSaving] = useState(false);
  const [savingPassword, setSavingPassword] = useState(false);
  const [isEye, setIsEye] = useState(false);
  const [isEye1, setIsEye1] = useState(false);
  const [isEye2, setIsEye2] = useState(false);
  const [passwordSubmitError, setPasswordSubmitError] = useState("");
  const [activeTab, setActiveTab] = useState("Profile");
  const [adminProfile, setAdminProfile] = useState(() => {
    const local = getProfile("admin") || {};
    return {
      name: local?.name || local?.full_name || "",
      email: local?.email || "",
      image: local?.image || local?.profile_image || "",
      imageFile: null,
    };
  });

  useEffect(() => {
    setSaving(true);
    dispatch(fetchAdminProfile())
      .then((res) => {
        const payload = res?.payload?.data ?? res?.payload ?? res?.data ?? {};
        const data = payload?.data ?? payload ?? {};
        if (!data || typeof data !== "object") return;
        setProfile("admin", data);
        setAdminProfile((prev) => ({
          ...prev,
          name: data?.name || data?.full_name || prev.name || "",
          email: data?.email || prev.email || "",
          image: data?.image || data?.profile_image || prev.image || "",
        }));
      })
      .finally(() => {
        setSaving(false);
      });
  }, []);

  useEffect(() => {
    if (state?.tab) {
      setActiveTab(state.tab);
    }
  }, [state]);

  const handleProfileChange = (field, value) => {
    setAdminProfile((prev) => ({ ...prev, [field]: value }));
  };

  const handleProfileSubmit = async (event) => {
    event.preventDefault();
    if (saving) return;
    setSaving(true);
    const formData = new FormData();
    formData.append("name", adminProfile.name || "");
    if (adminProfile.imageFile instanceof File) {
      formData.append("image", adminProfile.imageFile);
    }
    try {
      const response = await API_REQUEST({
        url: adminProfileEndPointURL,
        method: "PATCH",
        data: formData,
      });
      const updated = response?.data?.data ?? response?.data ?? {};
      if (updated && typeof updated === "object") {
        setProfile("admin", updated);
        setAdminProfile((prev) => ({
          ...prev,
          name: updated?.name || updated?.full_name || prev.name || "",
          email: updated?.email || prev.email || "",
          image: updated?.image || updated?.profile_image || prev.image || "",
          imageFile: null,
        }));
        window.dispatchEvent(new Event("admin-profile-updated"));
      }
    } finally {
      setSaving(false);
    }
  };

  const handlePasswordSubmit = async (values, resetForm) => {
    if (savingPassword) return;
    setPasswordSubmitError("");
    setSavingPassword(true);
    try {
      await API_REQUEST({
        url: adminChangePasswordEndPointURL,
        method: "POST",
        data: {
          old_password: values.current_password,
          new_password: values.new_password,
        },
      });
      if (resetForm) {
        resetForm();
      }
    } catch (error) {
      console.log({ error })
    } finally {
      resetForm();
      setSavingPassword(false);
    }
  };

  if (saving) {
    return <Loader />
  }
  return (
    <div>
      <AdminLayout user={adminProfile}>
        <div className="mt-4 ct_px_40 pb-5">
          <div className="ct_mb_20 d-flex align-items-center gap-3 justify-content-between gap-3 ct_flex_col_767 ">
            <div>
              <h4 className="ct_fs_20_new ct_fw_600 ct_darkblue_text">
                Setting
              </h4>
              <p className="mb-0 ct_grey_text">
                Update your admin account details
              </p>
            </div>
            <button className='ct_yellow_btn ct_h_48 ct_white_nowrap d-flex align-items-center gap-2 d-none'><i class="fa-solid fa-plus"></i>Add Admin Access</button>
          </div>
          <div className="row ct_pt_20 ct_border_top_1_op_10 ct_mt_20">
            <div className="col-lg-3 mb-4 ">
              <div className="ct_setting_tabs">
                <div
                  class="nav flex-column nav-pills me-3"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <button
                    class={`nav-link ${activeTab === "Profile" ? "active" : ""}`}
                    id="v-pills-General-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-General"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-General"
                    aria-selected="true"
                    onClick={() => setActiveTab("Profile")}
                  >
                    Profile
                  </button>
                  <button
                    class={`nav-link ${activeTab === "User Permissions" ? "active" : ""}`}
                    id="v-pills-User-Permissions-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-User-Permissions"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-User-Permissions"
                    aria-selected="false"
                    onClick={() => setActiveTab("User Permissions")}
                  >
                    User Permissions
                  </button>
                  {/* <button
                    class="nav-link "
                    id="v-pills-Subscription_&_Plan-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-Subscription_&_Plan"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-Subscription_&_Plan"
                    aria-selected="false"
                  >
                    Billing & Subscription
                  </button> */}
                  <button
                    class={`nav-link ${activeTab === "Email & Notifications" ? "active" : ""}`}
                    id="v-pills-Notifications-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-Notifications"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-Notifications"
                    aria-selected="false"
                    onClick={() => setActiveTab("Email & Notifications")}
                  >
                    Email & Notifications
                  </button>
                  <button
                    class={`nav-link ${activeTab === "Security" ? "active" : ""}`}
                    id="v-pills-Security_&_Password-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#v-pills-Security_&_Password"
                    type="button"
                    role="tab"
                    aria-controls="v-pills-Security_&_Password"
                    aria-selected="false"
                    onClick={() => setActiveTab("Security")}
                  >
                    Security
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-9  mb-4 ">
              <div class="tab-content" id="v-pills-tabContent">
                <div
                  class={`tab-pane fade ${activeTab === "Profile" ? "show active" : ""}`}
                  id="v-pills-General"
                  role="tabpanel"
                  aria-labelledby="v-pills-General-tab"
                >
                  <div className="ct_px_40">
                    <div>
                      <div>
                        <h4 className="ct_fs_16 ct_darkblue_text">
                          General Profile
                        </h4>
                        <p className="mb-0 ct_grey_text">
                          This is how others will see you on the Nuvio Platform
                        </p>
                      </div>
                      <form className="mt-4" onSubmit={handleProfileSubmit}>
                        <div className="row">
                          <div className="col-md-12 mb-4">
                            <div className="d-flex align-items-center gap-3 ct_flex_col_575">
                              <div className="ct_profile_pic ct_flex_shrink_0">
                                <img
                                  src={adminProfile.image || "/assets/img/user_profile.png"}
                                  alt="Admin"
                                />
                              </div>
                              <div className="ct_flex_1">
                                <label className="ct_upload_btn">
                                  Upload Profile Photo
                                  <input
                                    className="ct_file_input"
                                    type="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                      const file = event.currentTarget.files?.[0];
                                      if (file) {
                                        const previewUrl = URL.createObjectURL(file);
                                        handleProfileChange("imageFile", file);
                                        handleProfileChange("image", previewUrl);
                                      }
                                    }}
                                  />
                                </label>
                                <p className="ct_fs_12 ct_grey_text mb-0">
                                  Upload a clear profile image.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                              <label className="mb-2 ct_fs_14 ct_grey_text">
                                Name
                              </label>
                              <input
                                type="text"
                                className="form-control ct_input_border_8"
                                placeholder="Enter name"
                                value={adminProfile.name}
                                onChange={(e) =>
                                  handleProfileChange("name", e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                              <label className="mb-2 ct_fs_14 ct_grey_text">
                                Email
                              </label>
                              <input
                                type="email"
                                className="form-control ct_input_border_8"
                                value={adminProfile.email}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button
                            type="submit"
                            className="ct_yellow_btn ct_h_48 ct_white_nowrap"
                            disabled={saving}
                          >
                            {saving ? "Saving..." : "Save Changes"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${activeTab === "User Permissions" ? "show active" : ""}`}
                  id="v-pills-User-Permissions"
                  role="tabpanel"
                  aria-labelledby="v-pills-User-Permissions-tab"
                >
                  <div><h4 class="ct_fs_16 ct_darkblue_text">User Permissions</h4>
                    <p class="mb-0 ct_grey_text">Assign and manage admin access rights across key areas of the Nuvio Platform</p></div>
                  <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Date Created</th>
                          <th>Type Access</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            <div class="d-flex align-items-center gap-3">
                              <img src="../assets/img/user_22.jpeg" class="ct_img_40" />
                              <div>
                                <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                                <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='ct_publish_badge'>Active</span>
                          </td>
                          <td>30 Oct 2025</td>
                          <td>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select className='form-control ct_input border-0 w-auto' style={{ appearance: "auto" }}>
                                <option>Super Admin</option>
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                          </td>
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-ellipsis"></i></button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item">View Profile</a></li>
                                <li><a class="dropdown-item ct_darksky_blue_text" data-bs-target="#ct_edit_user_info" data-bs-toggle="modal">Edit User Info</a></li>
                                <li><a class="dropdown-item ct_yellow_text" data-bs-target="#ct_reactivate_account" data-bs-toggle="modal">Activate</a></li>
                                <li><a class="dropdown-item ct_orange_text" data-bs-target="#ct_suspend_account" data-bs-toggle="modal">Suspend</a></li>
                                <li><a class="dropdown-item text-danger" data-bs-target="#ct_remove_user" data-bs-toggle="modal">Remove</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            <div class="d-flex align-items-center gap-3">
                              <img src="../assets/img/user_22.jpeg" class="ct_img_40" />
                              <div>
                                <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                                <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='ct_publish_badge'>Active</span>
                          </td>
                          <td>30 Oct 2025</td>
                          <td>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select className='form-control ct_input border-0 w-auto' style={{ appearance: "auto" }}>
                                <option>Super Admin</option>
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                          </td>
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-ellipsis"></i></button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item">View Profile</a></li>
                                <li><a class="dropdown-item ct_darksky_blue_text" data-bs-target="#ct_edit_user_info" data-bs-toggle="modal">Edit User Info</a></li>
                                <li><a class="dropdown-item ct_yellow_text" data-bs-target="#ct_reactivate_account" data-bs-toggle="modal">Activate</a></li>
                                <li><a class="dropdown-item ct_orange_text" data-bs-target="#ct_suspend_account" data-bs-toggle="modal">Suspend</a></li>
                                <li><a class="dropdown-item text-danger" data-bs-target="#ct_remove_user" data-bs-toggle="modal">Remove</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>3</td>
                          <td>
                            <div class="d-flex align-items-center gap-3">
                              <img src="../assets/img/user_22.jpeg" class="ct_img_40" />
                              <div>
                                <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                                <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='ct_publish_badge'>Active</span>
                          </td>
                          <td>30 Oct 2025</td>
                          <td>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select className='form-control ct_input border-0 w-auto' style={{ appearance: "auto" }}>
                                <option>Super Admin</option>
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                          </td>
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-ellipsis"></i></button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item">View Profile</a></li>
                                <li><a class="dropdown-item ct_darksky_blue_text" data-bs-target="#ct_edit_user_info" data-bs-toggle="modal">Edit User Info</a></li>
                                <li><a class="dropdown-item ct_yellow_text" data-bs-target="#ct_reactivate_account" data-bs-toggle="modal">Activate</a></li>
                                <li><a class="dropdown-item ct_orange_text" data-bs-target="#ct_suspend_account" data-bs-toggle="modal">Suspend</a></li>
                                <li><a class="dropdown-item text-danger" data-bs-target="#ct_remove_user" data-bs-toggle="modal">Remove</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>4</td>
                          <td>
                            <div class="d-flex align-items-center gap-3">
                              <img src="../assets/img/user_22.jpeg" class="ct_img_40" />
                              <div>
                                <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                                <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='ct_draft_badge'>Invited</span>
                          </td>
                          <td>30 Oct 2025</td>
                          <td>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select className='form-control ct_input border-0 w-auto' style={{ appearance: "auto" }}>
                                <option>Super Admin</option>
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                          </td>
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-ellipsis"></i></button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item">View Profile</a></li>
                                <li><a class="dropdown-item ct_darksky_blue_text" data-bs-target="#ct_edit_user_info" data-bs-toggle="modal">Edit User Info</a></li>
                                <li><a class="dropdown-item ct_yellow_text" data-bs-target="#ct_reactivate_account" data-bs-toggle="modal">Activate</a></li>
                                <li><a class="dropdown-item ct_orange_text" data-bs-target="#ct_suspend_account" data-bs-toggle="modal">Suspend</a></li>
                                <li><a class="dropdown-item text-danger" data-bs-target="#ct_remove_user" data-bs-toggle="modal">Remove</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>5</td>
                          <td>
                            <div class="d-flex align-items-center gap-3">
                              <img src="../assets/img/user_22.jpeg" class="ct_img_40" />
                              <div>
                                <h5 class="ct_fs_16 ct_fw_600 mb-1">Nuray Aksoy</h5>
                                <p class="mb-0 ct_grey_text">nukrayaksoy@gmail.com</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className='ct_suspended'>Inactive</span>
                          </td>
                          <td>30 Oct 2025</td>
                          <td>
                            <div className="d-flex flex-column gap-2 position-relative">
                              <select className='form-control ct_input border-0 w-auto' style={{ appearance: "auto" }}>
                                <option>Super Admin</option>
                              </select>
                              <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                            </div>
                          </td>
                          <td>
                            <div class="ct_right_dropdown dropdown">
                              <button id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-ellipsis"></i></button>
                              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><a class="dropdown-item">View Profile</a></li>
                                <li><a class="dropdown-item ct_darksky_blue_text" data-bs-target="#ct_edit_user_info" data-bs-toggle="modal">Edit User Info</a></li>
                                <li><a class="dropdown-item ct_yellow_text" data-bs-target="#ct_reactivate_account" data-bs-toggle="modal">Activate</a></li>
                                <li><a class="dropdown-item ct_orange_text" data-bs-target="#ct_suspend_account" data-bs-toggle="modal">Suspend</a></li>
                                <li><a class="dropdown-item text-danger" data-bs-target="#ct_remove_user" data-bs-toggle="modal">Remove</a></li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-Subscription_&_Plan"
                  role="tabpanel"
                  aria-labelledby="v-pills-Subscription_&_Plan-tab"
                >
                  <div>
                    <h4 className="ct_fs_16 ct_darkblue_text">
                      Billing & Subscription
                    </h4>
                    <p className="mb-0 ct_grey_text">
                      Manage payment methods, view subscription details, and keep your account current across all Nuvio services
                    </p>
                  </div>

                  <div className="row ct_mt_60">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                      <div className="ct_light_purple_subscription_bg ">
                        <div className="d-flex align-items-center gap-3 justify-content-between">
                          <h4 className="ct_fs_14 ct_darkblue_text mb-0">
                            ENTERPRISE PRO
                          </h4>
                          <button className="ct_white_btn ct_white_nowrap">
                            Upgrade Plan
                          </button>
                        </div>
                        <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                          <div className='mb-4'>
                            <h4 className="ct_fs_24_new ct_fw_500">
                              $104.00 &nbsp;
                              <small className="ct_fs_14">USD</small>
                            </h4>
                            <p className='mb-0 ct_fs_14 ct_grey_text'>Price per month</p>
                          </div>
                          <div className="ct_right_vector_img_subs">
                            <img src="../assets/img/cuate.png" />
                          </div>
                        </div>
                      </div>
                      {/* <div className="ct_light_yellow_subscription_bg d-none">
                                      <div className="d-flex align-items-start gap-3 justify-content-between">
                                        <div>
                                          <h4 className="ct_fs_15 ct_fw_600 ct_darksky_blue_text mb-1">
                                           Title
                                          </h4>
                                          <p className="ct_yellow_text ct_fs_12 ct_fw_600">
                                           Subascription
                                          </p>
                                        </div>
                                        <button className="ct_white_btn ct_white_nowrap">
                                          Upgrade Plan
                                        </button>
                                      </div>
                                      <div className="d-flex align-items-center gap-3 justify-content-between mt-4">
                                        <div>
                                          <h4 className="ct_fs_24_new ct_fw_500">
                                           
                                            <small className="ct_fs_14">$50</small>
                                          </h4>
                                          <button className="ct_white_btn d-flex align-items-center gap-3 mt-3">
                                            <img src="../assets/img/warning-2.png" />
                                            <span className="ct_red_text   ">
                                              {" "}
                                             
                                              days left{" "}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="ct_right_vector_img_subs">
                                          <img src="../assets/img/cuate.png" />
                                        </div>
                                      </div>
                                    </div> */}
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0 pe-5">
                      <div className="ct_white_border_bg">
                        <div className="d-flex align-items-start justify-content-between gap-3">
                          <p className="ct_fs_14 mb-0">NEXT BILLING DATE</p>
                          <button
                            className="ct_red_btn_12 ct_white_nowrap"
                          >
                            Cancel Plan
                          </button>
                        </div>
                        <div className="mt-auto">
                          <h3 className="ct_fs_21 mb-2">
                            Dec. 24, 2025
                          </h3>
                          <p className="ct_grey_text ct_fs_14 mb-0">
                            This is your next billing date
                          </p>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="row ct_border_top_1_op_10 ct_mt_40 ct_pt_40 d-none">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                      <div className="">
                        <div className="mb-4">
                          <p className="ct_darkblue_text mb-1">Payment Method</p>
                          <p className="ct_grey_text ct_fs_14 mb-0">
                            Manage your credit cards and payment options.
                          </p>
                        </div>

                        <div className="ct_no_payment_empty_card">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.4"
                              d="M19 10.2769V17.4269C18.97 20.2769 18.19 20.9969 15.22 20.9969H5.78003C2.76003 20.9969 2 20.2469 2 17.2669V10.2769C2 7.57687 2.63 6.70687 5 6.56687C5.24 6.55687 5.50003 6.54688 5.78003 6.54688H15.22C18.24 6.54688 19 7.29687 19 10.2769Z"
                              fill="#292D32"
                            />
                            <path
                              d="M22 6.73V13.72C22 16.42 21.37 17.29 19 17.43V10.28C19 7.3 18.24 6.55 15.22 6.55H5.78003C5.50003 6.55 5.24 6.56 5 6.57C5.03 3.72 5.81003 3 8.78003 3H18.22C21.24 3 22 3.75 22 6.73Z"
                              fill="#292D32"
                            />
                            <path
                              d="M6.96027 18.5625H5.24023C4.83023 18.5625 4.49023 18.2225 4.49023 17.8125C4.49023 17.4025 4.83023 17.0625 5.24023 17.0625H6.96027C7.37027 17.0625 7.71027 17.4025 7.71027 17.8125C7.71027 18.2225 7.38027 18.5625 6.96027 18.5625Z"
                              fill="#292D32"
                            />
                            <path
                              d="M12.5504 18.5625H9.11035C8.70035 18.5625 8.36035 18.2225 8.36035 17.8125C8.36035 17.4025 8.70035 17.0625 9.11035 17.0625H12.5504C12.9604 17.0625 13.3004 17.4025 13.3004 17.8125C13.3004 18.2225 12.9704 18.5625 12.5504 18.5625Z"
                              fill="#292D32"
                            />
                            <path
                              d="M19 11.8594H2V13.3594H19V11.8594Z"
                              fill="#292D32"
                            />
                          </svg>
                          <h6 className="ct_fs_16 ct_dark_blue_text ct_mt_16">
                            No payment method
                          </h6>
                          <button className="ct_yellow_btn ct_outline_yellow_new ct_border_radius_100 ct_h_40 ct_yellow_text mx-auto mt-3">
                            Add Payment Method
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row ct_border_top_1_op_10 ct_mt_40 ct_pt_40">
                    <div className="col-lg-12 pe-5">
                      <div className="">
                        <div className="mb-4 d-flex align-items-center gap-3 justify-content-between ct_flex_col_575">
                          <div>
                            <p className="ct_darkblue_text mb-1">
                              Payment Method
                            </p>
                            <p className="ct_grey_text ct_fs_14 mb-0">
                              Manage your payment methods here.
                            </p>
                          </div>
                          <a
                            href="javascript:void(0)"
                            className="ct_fs_14 ct_yellow_link"
                          >
                            CHANGE PAYMENT METHOD
                          </a>
                        </div>

                        <div className="ct_payment_options_list">
                          <ul className="mb-0">
                            <li className="ct_payments_option_card">
                              <div className="d-flex align-items-center gap-3">
                                <img src="../assets/img/Visa.png" />
                                <div>
                                  <h6 className="ct_fs_16 mb-1">
                                    <span className="me-2">
                                      {" "}
                                      Visa Debit Card{" "}
                                    </span>
                                    <span
                                      className="ct_default_badge ct_orange_text "
                                      style={{
                                        background: "hsl(32deg 100% 49% / 20%)",
                                      }}
                                    >
                                      Default
                                    </span>
                                  </h6>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    **** **** **** 2897
                                  </p>
                                </div>
                              </div>
                              <div>
                                <img src="../assets/img/Delete_card.png" />
                              </div>
                            </li>
                            <li className="ct_payments_option_card">
                              <div className="d-flex align-items-center gap-3">
                                <img src="../assets/img/mastercard.png" />
                                <div>
                                  <h6 className="ct_fs_16 mb-1">
                                    <span className="me-2"> Mastercard </span>
                                    <span
                                      className="ct_default_badge ct_darksky_blue_text "
                                      style={{
                                        background: "hsl(199deg 64% 73% / 50%)",
                                      }}
                                    >
                                      Default
                                    </span>
                                  </h6>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    **** **** **** 2897
                                  </p>
                                </div>
                              </div>
                              <div>
                                <img src="../assets/img/Delete_card.png" />
                              </div>
                            </li>
                          </ul>
                        </div>

                        <div className="ct_border_top_1_op_10 pt-3 ct_mt_40">
                          <div className='d-flex align-items-center gap-3 justify-content-between ct_flex_col_767'>
                            <div>
                              <h4 className="ct_fs_18 mb-2">
                                Billing history
                              </h4>
                              <p className='mb-0 ct_fs_14 ct_grey_text' style={{ maxWidth: "565px" }}>Below are your receipts over the past 12 months. If you’d like to see additional receipts, please contact us at <a className='ct_yellow_text'>hello@nuvio.com</a></p>
                            </div>
                            <button
                              className="ct_yellow_btn   px-4 ct_h_40 ct_border_radius_10 ct_white_nowrap"

                            >
                              Download all <svg className='ms-2 ct_flex_shrink_0' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 7.33594V11.3359L7.33333 10.0026" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6.00033 11.3333L4.66699 10" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6663 6.66927V10.0026C14.6663 13.3359 13.333 14.6693 9.99967 14.6693H5.99967C2.66634 14.6693 1.33301 13.3359 1.33301 10.0026V6.0026C1.33301 2.66927 2.66634 1.33594 5.99967 1.33594H9.33301" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.6663 6.66927H11.9997C9.99967 6.66927 9.33301 6.0026 9.33301 4.0026V1.33594L14.6663 6.66927Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>

                            </button>
                          </div>

                          <div className="mt-3">
                            <div class="table-responsive ct_custom_table ct_custom_table2 ct_billing_table_2 pt-2">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th className='py-2 px-4'>#</th>
                                    <th className='py-2 px-4'>Bill date</th>
                                    <th className='py-2 px-4'>Amount</th>
                                    <th className='py-2 px-4'>Status</th>
                                    <th className='py-2 px-4'></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>
                                      December 24, 2023
                                    </td>
                                    <td>$240.00</td>
                                    <td><span class="ct_draft_badge w-auto d-inline-block px-3 ct_border_radius_5 border-0">Paid</span></td>
                                    <td><svg className='me-2' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.66699 6.66406L8.00033 9.9974L11.3337 6.66406" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8 10V2" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                      Download</td>


                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td>
                                      December 24, 2023
                                    </td>
                                    <td>$240.00</td>
                                    <td><span class="ct_failed_red_badge w-auto d-inline-block px-3 ct_border_radius_5 border-0">Failed</span></td>
                                    <td><svg className='me-2' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.66699 6.66406L8.00033 9.9974L11.3337 6.66406" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8 10V2" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                      Download</td>


                                  </tr>

                                  <tr>
                                    <td>3</td>
                                    <td>
                                      December 24, 2023
                                    </td>
                                    <td>$240.00</td>
                                    <td><span class="ct_draft_badge w-auto d-inline-block px-3 ct_border_radius_5 border-0">Paid</span></td>
                                    <td><svg className='me-2' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.66699 6.66406L8.00033 9.9974L11.3337 6.66406" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8 10V2" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                      Download</td>


                                  </tr>
                                  <tr>
                                    <td>4</td>
                                    <td>
                                      December 24, 2023
                                    </td>
                                    <td>$240.00</td>
                                    <td><span class="ct_failed_red_badge w-auto d-inline-block px-3 ct_border_radius_5 border-0">Failed</span></td>
                                    <td><svg className='me-2' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.66699 6.66406L8.00033 9.9974L11.3337 6.66406" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M8 10V2" stroke="#606161" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                      Download</td>


                                  </tr>



                                </tbody>
                              </table>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div
                  class={`tab-pane fade ${activeTab === "Email & Notifications" ? "show active" : ""}`}
                  id="v-pills-Notifications"
                  role="tabpanel"
                  aria-labelledby="v-pills-Notifications-tab"
                >
                  <div>
                    <h4 className="ct_fs_16 ct_darkblue_text">
                      Email & Notification
                    </h4>
                    <p className="mb-0 ct_grey_text">
                      Control what admin alerts, platform updates, and user actions you want to be notified about
                    </p>
                  </div>

                  <ul className='mt-4'>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>Weekly Platform Summary</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>A weekly email overview of user activity, submissions & traffic</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3 mt-4'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>New User Sign-Ups</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>Get notified when a new user registers (freelancer, coach, etc)</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3 mt-4'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>New Project Submission (Founder)</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>Alert when a founder submits a new project for funding</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3 mt-4'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>New Job Post (Enterprise)</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>Notify when a new job is posted by an enterprise user</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3 mt-4'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>Payment Failure Alerts</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>Alert when a user payment fails or is declined</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                    <li className='ct_outline_bg d-flex align-items-start gap-3 justify-content-between gap-3 py-3 mt-4'>
                      <div>
                        <h4 className='ct_fs_18 ct_fw_400 ct_darkblue_text mb-2'>Marketing Updates & Product Announcement</h4>
                        <p className='mb-0 ct_fs_14 ct_grey_text'>Occasional product news, tips and promotions</p>
                      </div>
                      <div class="d-flex align-items-center gap-2">
                        <label class="toggle-switch ct_toggle_switch_h_16 ct_white_nowrap">
                          <input type="checkbox" />
                          <div class="toggle-switch-background">
                            <div class="toggle-switch-handle"></div>
                          </div>
                        </label>
                        <span className="ct_white_nowrap ct_fs_14 ct_darkblue_text"> Enable</span>
                      </div>

                    </li>
                  </ul>

                  <div className='mt-4 row pt-4' style={{ borderTop: "1px solid rgb(154 150 164 / 10%)" }}>
                    <div className='col-md-6 mb-4 mb-md-0'>
                      <h4 className='ct_fs_16 ct_darkblue_text ct_mb_16'>How often do you want to be notified?</h4>
                      <ul>
                        <li>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              Instantly (real-time alerts)
                            </label>
                          </div>
                        </li>
                        <li className='ct_mt_10'>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              Daily Digest (once per day)
                            </label>
                          </div>
                        </li>
                        <li className='ct_mt_10'>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              Weekly Summary (once a week)
                            </label>
                          </div>
                        </li>
                      </ul>

                    </div>

                    <div className='col-md-6 mb-4 mb-md-0'>
                      <h4 className='ct_fs_16 ct_darkblue_text ct_mb_16'>Choose your preferred delivery method?</h4>
                      <ul>
                        <li>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              Email
                            </label>
                          </div>
                        </li>
                        <li className='ct_mt_10'>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              In-app
                            </label>
                          </div>
                        </li>
                        <li className='ct_mt_10'>
                          <div className="form-check ct_custom_check2 ct_custom_check2_yellow d-flex align-items-center gap-2" style={{ width: "16px", height: "16px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label for="" className="ct_darkblue_text ct_white_nowrap">
                              SMS (optional can be added later)
                            </label>
                          </div>
                        </li>
                      </ul>

                    </div>



                  </div>

                  <div className='mt-4 text-end'>
                    <button className='ct_yellow_btn ct_h_48 ms-auto'>Save Notification</button>
                  </div>




                </div>
                <div
                  class={`tab-pane fade ${activeTab === "Security" ? "show active" : ""}`}
                  id="v-pills-Security_&_Password"
                  role="tabpanel"
                  aria-labelledby="v-pills-Security_&_Password-tab"
                >
                  <div>
                    <h4 className="ct_fs_16 ct_darkblue_text">
                      Security & Password
                    </h4>
                    <p className="mb-0 ct_grey_text">
                      Manage your login credentials, enable extra protection and keep your admin account secure at all times
                    </p>
                  </div>


                  <Formik
                    initialValues={{
                      current_password: "",
                      new_password: "",
                      confirm_password: "",
                    }}
                    validationSchema={changePasswordSchema}
                    onSubmit={(values, { resetForm }) => {
                      handlePasswordSubmit(values, resetForm);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      resetForm,
                    }) => (
                      <form className="mt-4" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                              <label className="mb-2 ct_fs_14 ct_grey_text">
                                Current Password
                              </label>
                              <div className="position-relative">
                                <input
                                  type={isEye ? "text" : "password"}
                                  className="form-control ct_input ct_border_op_10 pe-5"
                                  placeholder="Current Password"
                                  id="current_password"
                                  name="current_password"
                                  value={values.current_password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <Eye isEye={isEye} onClick={() => setIsEye(!isEye)} />
                              </div>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="current_password"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                              <label className="mb-2 ct_fs_14 ct_grey_text">
                                New Password
                              </label>
                              <div className="position-relative">
                                <input
                                  type={isEye1 ? "text" : "password"}
                                  className="form-control ct_input ct_border_op_10 pe-5"
                                  placeholder="New Password"
                                  id="new_password"
                                  name="new_password"
                                  value={values.new_password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <Eye isEye={isEye1} onClick={() => setIsEye1(!isEye1)} />
                              </div>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="new_password"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                              <label className="mb-2 ct_fs_14 ct_grey_text">
                                Confirm Password
                              </label>
                              <div className="position-relative">
                                <input
                                  type={isEye2 ? "text" : "password"}
                                  className="form-control ct_input ct_border_op_10 pe-5"
                                  placeholder="Confirm Password"
                                  id="confirm_password"
                                  name="confirm_password"
                                  value={values.confirm_password}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                                <Eye isEye={isEye2} onClick={() => setIsEye2(!isEye2)} />
                              </div>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="confirm_password"
                              />
                            </div>
                          </div>
                        </div>

                        {passwordSubmitError ? (
                          <p className="ct_fs_14 mb-0" style={{ color: "red" }}>
                            {passwordSubmitError}
                          </p>
                        ) : null}
                        <div className="d-flex align-items-center  gap-3 mt-4">
                          <button
                            className="ct_yellow_btn ct_outline_light_grey px-5 ct_h_48"
                            type="button"
                            onClick={() => {
                              setPasswordSubmitError("");
                              resetForm();
                            }}
                          >
                            Discard
                          </button>
                          <button
                            className="ct_yellow_btn px-5 ct_h_48"
                            type="submit"
                            disabled={savingPassword}
                          >
                            {savingPassword ? "Saving..." : "Save New Password"}
                          </button>
                        </div>
                      </form>
                    )}
                  </Formik>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade modal-lg"
          id="ct_add_payment_method"
          tabindex="-1"
          aria-labelledby="ct_create_eventLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content ">
              <div class="modal-header border-0">
                <button
                  type="button"
                  class="btn-close ct_circle_close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body px-5 pb-5 ">
                <div className="text-center">
                  <h4 class=" mb-1 ct_fs_24_new ct_darksky_blue_text px-4">
                    Payment method
                  </h4>
                  <p class="mb-0 ct_grey_text ct_fs_12 px-4">
                    Update, change, or add a payment method securely for
                    hassle-free billing.
                  </p>
                </div>
                <div className="ct_mt_30">
                  <div className="form-check ct_custom_check2 ct_custom_check_sky_blue  d-flex align-items-center gap-2 mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label for="" className="ct_darksky_blue_text">
                      Business Purchase
                    </label>
                  </div>

                  <div className="mb-3">
                    <label className="ct_fs_14 ct_darkblue_text mb-2">
                      Choose payment method
                    </label>
                    <div className="d-flex align-items-center gap-3">
                      <div className="ct_select_payment_type">
                        <img src="../assets/img/visa_big_logo.png" />
                      </div>
                      <div className="ct_select_payment_type">
                        <img src="../assets/img/mastercard_small.png" />
                      </div>
                      <div className="ct_select_payment_type">
                        <img src="../assets/img/pay_pal.png" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-2">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Country{" "}
                        </label>
                        <div className="d-flex flex-column gap-2 position-relative">
                          <select className="form-control ct_input">
                            <option>France</option>
                          </select>
                          <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-2">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Name on card
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="Enter  name on card"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-2">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Card number
                        </label>
                        <input
                          type="text"
                          className="form-control ct_input"
                          placeholder="Enter  card number"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          Expiration date
                        </label>
                        <input type="date" className="form-control ct_input" />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group mb-2">
                        <label className="ct_fs_14 ct_darkblue_text mb-2">
                          CVC/CVV
                        </label>
                        <input
                          type="number"
                          className="form-control ct_input"
                          placeholder=" CVC/CVV"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center justify-content-center gap-3 mt-4">
                    <button class="ct_yellow_btn ct_grey_btn ct_h_44  px-5">
                      <i
                        class="fa-solid fa-arrow-left me-1"
                        style={{ color: "#535862" }}
                      ></i>{" "}
                      Back
                    </button>
                    <button
                      class="ct_yellow_btn  ct_sky_blue_btn ct_h_44 px-5"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_submit_modal"
                    >
                      Add method
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade ct_submit_modal "
          id="ct_submit_modal"
          tabindex="-1"
          aria-labelledby="ct_submit_modalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body py-5">
                <div class="mx-auto d-block text-center mb-4">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                      fill="#219EBC"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_18 mx-auto" style={{ maxWidth: "337px" }}>
                    Done! Your payment method is ready to use.
                  </h4>
                </div>
                <div class="text-center mt-4">
                  <button
                    class="ct_yellow_btn ct_h_48 mx-auto px-5 ct_sky_blue_btn"
                    data-bs-dismiss="modal"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade ct_suspend_account"
          id="ct_suspend_account"
          tabindex="-1"
          aria-labelledby="ct_suspend_accountLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body py-5">
                <div class="mx-auto d-block text-center mb-4">
                  <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 44V8C4 6.9 4.392 5.95867 5.176 5.176C5.96 4.39333 6.90133 4.00133 8 4H40C41.1 4 42.042 4.392 42.826 5.176C43.61 5.96 44.0013 6.90133 44 8V32C44 33.1 43.6087 34.042 42.826 34.826C42.0433 35.61 41.1013 36.0013 40 36H12L4 44ZM24 30C24.5667 30 25.042 29.808 25.426 29.424C25.81 29.04 26.0013 28.5653 26 28C25.9987 27.4347 25.8067 26.96 25.424 26.576C25.0413 26.192 24.5667 26 24 26C23.4333 26 22.9587 26.192 22.576 26.576C22.1933 26.96 22.0013 27.4347 22 28C21.9987 28.5653 22.1907 29.0407 22.576 29.426C22.9613 29.8113 23.436 30.0027 24 30ZM22 22H26V10H22V22Z"
                      fill="#023047"
                    />
                  </svg>
                </div>
                <div class="text-center">
                  <h4 class="ct_fs_20">Suspend User Account</h4>
                  <p>
                    Are you sure you want to suspend
                    <span class="ct_orange_text">Nuray Aksoy</span> account? This
                    will temporarily restrict access to her account on Nuvio.
                  </p>
                </div>
                <div class="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                  <button
                    class="ct_yellow_btn ct_outline_grey ct_h_48 w-100 px-5 ct_w_100_575"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button class="ct_yellow_btn ct_h_48 mx-auto px-5 w-100 ct_w_100_575 ct_red_btn">
                    Suspend
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  )
}

export default Setting

